import { render } from "./Loader.vue?vue&type=template&id=b1d7b478"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1d7b478"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1d7b478', __exports__)) {
    api.reload('b1d7b478', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=b1d7b478", () => {
    api.rerender('b1d7b478', render)
  })

}


export default __exports__